module.exports.LANDING_STEP = {
  INTRO: 0,
  EMAIL_INPUT: 1,
  URL_INPUT: 2,
  SELECT_COMPARISON_AD: 3,
  BUILDING_REPORT: 4,
  REPORT_AVAILABLE: 5
}

module.exports.CONFIG = {
  THEME_COLOR: '#305BE8'
};

module.exports.SERVER_API = {
  BASE_URL: 'https://hooks.api.vidtao.com'
};
